import { getID } from './tool'

export const StepSet = {
  'basic': '基本規定',
  'hours': '工時規定',
  'leave': '假日規定',
  'overtime': '加班規定',
}



// WEBPACK FOOTER //
// ./src/settings/Step.js